export class IdViewModel {
    ids: number[];
    cols: string;

    selectedDistrictIds: number[]
}